import { render } from "./MasterOrdersView.vue?vue&type=template&id=24ec0ba4&scoped=true"
import script from "./MasterOrdersView.vue?vue&type=script&lang=js"
export * from "./MasterOrdersView.vue?vue&type=script&lang=js"

import "./MasterOrdersView.vue?vue&type=style&index=0&id=24ec0ba4&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24ec0ba4"]])

export default __exports__